module.exports = __webpack_public_path__ + "b90a5faa4f5c5794bcebbc26fcacfb05.svg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/radio-kangol-logo-black.svg
 ** module id = 494
 ** module chunks = 0
 **/